const staticsTokens = {
  apiClient: Symbol(),
  repository: Symbol(),
  countryPresenter: Symbol(),
  getCountriesUseCase: Symbol(),
}

export default staticsTokens
